/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Type_HouseInputs */

const cs_public_site_demand_type_house = /** @type {(inputs: Public_Site_Demand_Type_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dům`)
};

const en_public_site_demand_type_house = /** @type {(inputs: Public_Site_Demand_Type_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House`)
};

/**
* | output |
* | --- |
* | "House" |
*
* @param {Public_Site_Demand_Type_HouseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_type_house = /** @type {((inputs?: Public_Site_Demand_Type_HouseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Type_HouseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_type_house(inputs)
	return cs_public_site_demand_type_house(inputs)
});